export const TOGGLE_DRAWER = 'TOGGLE_DRAWER'

export const SET_DRAWER = 'SET_DRAWER'

export const toggleDrawer = () => ({
    type: TOGGLE_DRAWER,
})

export const setDrawer = (value: boolean) => ({
    type: SET_DRAWER,
    payload: value,
})
